import { useCallback } from "react";
import { mainBus } from "@/common/buses";

export const useFullscreenToggle = () => {
  return useCallback(() => {
    mainBus.emit("toggle_fullscreen");
  }, []);
};
